import { NAVIGATION_ACTIONS } from './navigation.actions';
import { INavigationConfigurationInterface } from '../interfaces';
import { NavigationInitState } from '@ispm/navigation/store/navigation.state';
import { IgenomicsAction } from '@ispm/core/interfaces/genomics-action.interface';

export function navigationReducer(
    state: INavigationConfigurationInterface = NavigationInitState,
    action: IgenomicsAction
): INavigationConfigurationInterface {
  let newState;

  switch (action.type) {
    case NAVIGATION_ACTIONS.SET_WEB_CONFIG:
      newState = Object.assign({ }, state);
      newState.init = true;
      newState.selected = null;

      if (action.payload.navigation) {
        newState.selected = action.payload.navigation.selected || null;
      }

      newState.navigation = action.payload.navigation;
      newState.dashboard = action.payload.dashboard;
      newState.aboutBoxContent = action.payload.aboutBoxContent;
      newState.filterByOrgContext = action.payload.filterByOrgContext ? action.payload.filterByOrgContext : false;

      return { ...newState };
    case NAVIGATION_ACTIONS.SET_MENU_STATE: {
      newState = Object.assign({ }, state);
      newState.currentSelected = { ...action.payload.navigation };

      return { ...newState };
    }
    case NAVIGATION_ACTIONS.SET_CURRENT_APP: {
      newState = Object.assign({ }, state);
      newState.currentApp = action.payload;

      return newState;
    }
    case NAVIGATION_ACTIONS.SET_CURRENT_APP_SELECTED_TAB: {
      newState = Object.assign({ }, state);
      newState.currentAppSelectedTab = action.payload;

      return newState;
    }
    default:
      return state;
  }
}
